module.exports = __webpack_public_path__ + "media/components/global/photos-banner/img/hot_air_balloon-large-475183124b92126f02cfdf725f572912.jpg";